import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import Loader from '../../Atoms/Loader';
import Tag from '../../Atoms/Tag';

import Card from '../../Molecules/Card';
import MembersAvatars from '../../Molecules/MembersAvatars';
import InvisibleAccordion from './Molecules/InvisibleAccordion';

import InviteMembersModal from '../../Parts/InviteMembersModal';
import AddUserModal from '../../Parts/AddUserModal';
import FileListTabs from './Parts/FileListTabs';
import WarningNotification from '../../Molecules/Notifications/WarningNotification';

import { FaUpRightFromSquare, FaPaperclip, FaSliders , FaStar, FaRegStar } from "react-icons/fa6";
import { FaRegTrashAlt, FaPaintBrush } from "react-icons/fa";
import { BsLightningCharge } from "react-icons/bs";
import { TbNewSection } from "react-icons/tb";
import { BiEdit } from "react-icons/bi";


import { getTimeAgo } from '../../../utils/sharedFunctions';

import useBrainstormStore from '../../../hooks/useBrainstormStore';

export default function ProjectTemplate({
    project,
    loadingProject,
    favoriteFunction,
    knowledgeBaseFiles,
    loadKnowledgeBaseFiles,
    downloadFileFunction,
    renameFileFunction,
    workspaceItems,
    loadWorkspaceItems
}) {
    const params = useParams();
    const navigate = useNavigate();
    const { createBrainstorm, getBrainstormsByProject, deleteBrainstormByProjectId } = useBrainstormStore();

    const [inviteMembersModal, setInviteMembersModal] = useState(false);
    const [addUserModal, setAddUserModal] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [membersReloadKey, setMembersReloadKey] = useState(0);

    useEffect(() => {
        checkDraftBrainstorm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkDraftBrainstorm = () => {
        const projectId = params.id;
        const currentBrainstorm = getBrainstormsByProject(parseInt(projectId));
        if (currentBrainstorm.length > 0 && currentBrainstorm[0]?.challenges.length !== 0) {
            setShowNotification(true);
        }
    }

    const handleDelete = () => {
        const projectId = params.id;
        deleteBrainstormByProjectId(parseInt(projectId));
        setShowNotification(false);
    };

    const handleContinueDraft = () => {
        const projectId = params.id;
        const currentBrainstorm = getBrainstormsByProject(projectId);

        if (currentBrainstorm[0].step === 2) {
            navigate(`/brainstorm/ideas/${projectId}`, { state: { isUpdating: true } });
        } else if (currentBrainstorm[0].step === 3) {
            navigate(`/brainstorm/concepts/${projectId}`, { state: { isUpdating: true } });
        } else {
            navigate(`/brainstorm/${projectId}`, { state: { isUpdating: true } });
        }
        
        setShowNotification(false);
    };

    const handleCloseWarning = () => {
        setShowNotification(false);
    };

    const draftButtons = [
        {
            text: 'Apagar',
            icon: <FaRegTrashAlt color='#ef4444' />,
            onClick: handleDelete
        },
        {
            text: 'Continuar editando',
            icon: <BiEdit />,
            onClick: handleContinueDraft
        }
    ];

    const handleEditProjectSummary = () => {
        navigate(`/edit-project/${project?.id}/`);
    }

    const handleOpenBrainstorm = () => {
        const currentBrainstorm = getBrainstormsByProject(project.id);

        if (currentBrainstorm.length === 0) {
            createBrainstorm(project.id);
        } else {
            if (currentBrainstorm[0].step === 1) {
                navigate(`/brainstorm/${project.id}`);
            } else {
                navigate(`/brainstorm/ideas/${project.id}`);
            }
        }
    }

    return (
        <div>
             <InviteMembersModal
                isOpen={inviteMembersModal}
                onClose={() => setInviteMembersModal(false)}
                projectId={project?.id}
            />

            <AddUserModal
                isOpen={addUserModal}
                onClose={() => setAddUserModal(false)}
                projectId={project?.id}
                onSuccess={() => setMembersReloadKey(prev => prev + 1)}
            />

            <WarningNotification
                text="Você tem um trabalho de Brainstorm em andamento"
                position="top-center"
                buttons={draftButtons}
                onClose={handleCloseWarning}
                show={showNotification && !loadingProject}
            />

            {loadingProject ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <Loader/>
                </div>
            ): (
                <div className="container-xxl my-5">
                    <div id="first-header" className='d-flex flex-row justify-content-between align-items-center gap-2'>
                        <h1>{project?.name || 'Carregando...'}</h1>
                        <div className='d-flex flex-row align-items-center gap-1'>
                            {/* <button
                                className='btn'
                                onClick={() => alert("Abrir publicados (em breve)")}
                            >
                                <FaUpRightFromSquare />
                            </button> */}

                            <button
                                className='btn'
                                onClick={() => alert("Anexar arquivos á base (em breve)")}
                            >
                                <FaPaperclip />
                            </button>

                            <button
                                className='btn'
                                title='Adicionar usuário'
                                onClick={() => setAddUserModal(true)}
                            >
                                <FaPaintBrush />
                            </button>

                            <button 
                                className='btn'
                                onClick={() => navigate(`/edit-project/${project.id}/`)}
                            >
                                <FaSliders  />
                            </button>

                            <button
                                className='btn'
                                onClick={() => favoriteFunction(project.id, project.isFavorite)}
                            >
                                {project?.isFavorite ? <FaStar color='#FFD700' /> : <FaRegStar />}
                            </button>
                        </div>
                    </div>

                    <div id="second-header" className='mb-2'>
                        <div className="d-flex flex-row align-items-center gap-2 mb-3">
                            <Tag
                                text={
                                    typeof project?.company === 'object' 
                                        ? project?.company?.name 
                                        : project?.company
                                } 
                            />

                            {project?.members?.length > 0 && (
                                <MembersAvatars members={project?.members} />
                            )}

                            {project?.last_user_updated && (
                                <p>Editado por {project.last_user_updated}</p>
                            )}

                            {project?.updatedAt && (
                                <p className='text-secondary'>{getTimeAgo(project.updatedAt)}</p>
                            )}
                        </div>
                    </div>

                    <div id="project-summary" className='mb-5'>
                            <div className="mb-4">
                                <InvisibleAccordion 
                                    content={project?.project_summary || 'Carregando...'}
                                    maxLength={250}
                                    showMoreText="Ver mais"
                                    showLessText="Ver menos"
                                    editFunction={handleEditProjectSummary}
                                />
                            </div>
                    </div>

                    <div id="tools" className='mb-5'>
                        <p className='mb-3'>Ferramentas sugeridas</p>
                        <div className='d-flex flex-row align-items-center gap-2 flex-wrap'>
                            
                            <button
                                className='border-0 bg-transparent text-light'
                                onClick={() => handleOpenBrainstorm()}
                            >
                                <Card styles={{ marginRight: '10px' }}>
                                    <div className='d-flex flex-row align-items-center gap-2'>
                                        <div style={{ backgroundColor: '#FFD6A8', padding: '3px 8px', borderRadius: '15px' }}>
                                            <BsLightningCharge color='#CA3500' />
                                        </div>
                                        Brainstorm
                                    </div>
                                </Card>
                            </button>

                            <button
                                className='border-0 bg-transparent text-light'
                                onClick={() => {
                                    const formUrl = process.env.REACT_APP_FORM_REGISTER_URL || 'https://docs.google.com/forms/d/e/1FAIpQLSd_bxP3dPPpnAY7LxUYAnr6Q3tFmb8V05CbYB5Y1XX2PwuWEA/viewform?usp=dialog';
                                    return Swal.fire({
                                        title: 'Acesse mais ferramentas',
                                        html: `Acesse mais ferramentas na versão POC da Aira para MJVers.<br/><br/>Você será redirecionado e terá que fazer o login com o seu email e senha.<br/><br/>Caso ainda não tenha login, <a href="${formUrl}" target="_blank" rel="noopener noreferrer" style="color:#6f42c1;text-decoration:underline;">solicite aqui</a>.`,
                                        showConfirmButton: true,
                                        confirmButtonText: 'Acessar',
                                        confirmButtonColor: '#6f42c1',
                                        background: '#27272A',
                                        color: '#fff',
                                        icon: "info",
                                        iconColor: "#6f42c1"
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            window.open(process.env.REACT_APP_MVP_AIRA_URL || 'https://aira-mvp.mjvmobile.com.br/', '_blank', 'noopener,noreferrer');
                                        }
                                    })}
                                }
                            >
                                <Card styles={{ marginRight: '10px' }}>
                                    <div className='d-flex flex-row align-items-center gap-2'>
                                        <div style={{ backgroundColor: '#B8E6FE', padding: '3px 8px', borderRadius: '15px' }}>
                                            <TbNewSection color='#00598A' />
                                        </div>
                                        Mais ferramentas
                                    </div>
                                </Card>
                            </button>
                        </div>
                    </div>

                    <div>
                        <FileListTabs
                            projectId={project?.id}
                            workspaceItems={workspaceItems}
                            loadWorkspaceItems={loadWorkspaceItems}
                            knowledgeBaseFiles={knowledgeBaseFiles}
                            loadKnowledgeBaseFiles={loadKnowledgeBaseFiles}
                            downloadFileFunction={downloadFileFunction}
                            renameFileFunction={renameFileFunction}
                            projectName={project?.name}
                            companyName={typeof project?.company === 'object' ? project?.company?.name : project?.company}
                            membersReloadKey={membersReloadKey}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}